import React, { useEffect, useState } from "react";

function AttendedAppointments() {

    const [appointments, setAppointments] = useState([]);

    useEffect(() => {

        fetch("https://script.google.com/macros/s/AKfycbyYWBR_JtS9R3KC33JbwiirmelpmD16D-8Br3CTNIdcNFjOJXfHrdmgHUDJv5RRu_tqig/exec")
            .then(res => res.json())
            .then(data => {

                const attended = data.filter(a => a.status === "Attended")
                setAppointments(attended)

            })

    }, [])

    return (

        <div className="container mt-4">

            <h3>Attended Appointments</h3>

            <table className="table">

                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Concern</th>
                        <th>Date</th>
                    </tr>
                </thead>

                <tbody>

                    {appointments.map((a) => (

                        <tr key={a.id}>
                            <td>{a.name}</td>
                            <td>{a.phone}</td>
                            <td>{a.concern}</td>
                            <td>{a.date}</td>
                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    )

}

export default AttendedAppointments